import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Root element #root not found");
}

// IMPORTANT: Keep the static HTML fallback visible for crawlers and partial-JS clients.
// Only remove it after the React app successfully bootstraps.
try {
  createRoot(rootEl).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  requestAnimationFrame(() => {
    // Mark hydration as successful; standalone HTML entrypoints can safely hide fallbacks.
    document.documentElement.dataset.hydrated = "1";
    document.getElementById("static-fallback")?.remove();
  });
} catch (err) {
  // If React fails to boot, leave the fallback in place.
  // eslint-disable-next-line no-console
  console.error(err);
}
